import { render, staticRenderFns } from "./SplashGif.vue?vue&type=template&id=2d657236&scoped=true"
import script from "./SplashGif.vue?vue&type=script&lang=ts"
export * from "./SplashGif.vue?vue&type=script&lang=ts"
import style0 from "./SplashGif.vue?vue&type=style&index=0&id=2d657236&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d657236",
  null
  
)

export default component.exports